export default [
  {
    key: "mode",
    label: "label.mode",
    type: "single-selection",
    selectionKey: "value",
    selectionLabel: "label",
    reduce: true,
    options: [
      { label: "option.local", value: "local" },
      { label: "option.staging", value: "staging" },
      { label: "option.production", value: "production" },
    ],
    rules: "required",
    class: "single-selection-mode",
    cols: 2,
  },
  {
    key: "forwardMessageHook",
    label: "label.forwardMessageHook",
    type: "text",
    cols: 6,
  },
  {
    key: "forwardMessageHookAuthKey",
    label: "label.forwardMessageHookAuthKey",
    type: "text",
    cols: 6,
  },
  {
    key: "domain",
    class: "d-block",
    label: "label.domain",
    type: "text",
    rules: "required|url",
    cols: 6,
  },
  {
    key: "appId",
    label: "label.appId",
    type: "text",
    rules: "required",
    cols: 6,
  },
  {
    key: "appSecret",
    label: "label.appSecret",
    type: "textarea",
    rules: "required",
    cols: 6,
  },
  {
    key: "appKey",
    label: "label.appKey",
    type: "textarea",
    rules: "required",
    cols: 6,
  },
];
